import { useTranslations } from "next-intl";

type TranslateOptions = {
  defaultMessage?: string;
  values?: Record<string, any>;
};

export function safeT(t: ReturnType<typeof useTranslations>, key: string, options?: TranslateOptions): string {
  const hasKey = t.has(key);

  if (hasKey) {
    try {
      return t(key, options?.values);
    } catch {
      return options?.defaultMessage ?? key;
    }
  }

  return options?.defaultMessage ?? key;
}
